export default "__VITE_ASSET__DspHuOvd__"